const kingDee = [{
  desc: '客户查询接口',
  options: {
    url: '/kingDee/queryCustomers'
  }
}, {
  desc: '添加安诚业务明细',
  options: {
    url: '/kingDee/addAdjustBudget',
    method: 'post'
  }
}, {
  desc: '删除安诚业务明细',
  options: {
    url: '/kingDee/deleteAdjustBudget',
    method: 'post'
  }
}]
export default kingDee



// WEBPACK FOOTER //
// ./src/api/kingDee.js